var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { ReactRouter } from "@atlassiansox/microscopekit";
import { Radio } from "@atlaskit/radio";
import { useCreateWargameExercise } from "../../../hooks";
import { FormModal, WargameExerciseForm } from "../../../components";
import { useAnalytics, useSendScreenEvent } from "../../../analytics";
import Lozenge from "@atlaskit/lozenge";
import styled from "styled-components";
var WargameAction;
(function (WargameAction) {
    WargameAction["Exercise"] = "Exercise";
    WargameAction["Plan"] = "Plan";
})(WargameAction || (WargameAction = {}));
export var CreateWargame = function (_a) {
    var serviceId = _a.serviceId, isVisible = _a.isVisible, onHide = _a.onHide;
    var history = ReactRouter.useHistory();
    var url = ReactRouter.useRouteMatch().url;
    var _b = __read(useState(""), 2), selectedAction = _b[0], setSelectedAction = _b[1];
    var _c = useCreateWargameExercise(onHide), createWargameExercise = _c.createWargameExercise, isCreatingWargameExercise = _c.isCreatingWargameExercise;
    var sendUIEvent = useAnalytics().sendUIEvent;
    useSendScreenEvent("createWargameModal", isVisible);
    var onSubmit = function (_a) {
        var name = _a.name, dueDate = _a.dueDate;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                sendUIEvent({
                    source: "homeScreen",
                    actionSubject: "modal",
                    action: "selected",
                    actionSubjectId: "createWargameModal",
                    attributes: {
                        selectedWargameFlow: selectedAction
                    }
                });
                if (selectedAction === WargameAction.Plan) {
                    onHide();
                    history.push(url + "/create-template");
                }
                else {
                    return [2 /*return*/, createWargameExercise({ name: name, endDate: dueDate, service: serviceId })];
                }
                return [2 /*return*/];
            });
        });
    };
    return (React.createElement(FormModal, { isOpen: isVisible, heading: "Create Wargame", actions: {
            submit: { text: "Go", onSubmit: onSubmit, isSubmitting: isCreatingWargameExercise },
            close: { text: "Cancel", onClose: onHide }
        } },
        React.createElement(WargameActionOption, { value: WargameAction.Exercise, onChange: setSelectedAction, selectedAction: selectedAction, title: createWargameExerciseTitle },
            React.createElement("ul", null,
                React.createElement("li", null, "Kickoff the Wargame Jira workflow, add or import wargame plans and execute the wargame exercise"),
                React.createElement("li", null,
                    React.createElement("strong", null, "Recommended"),
                    " for official reports as this data will surface in",
                    " ",
                    React.createElement("a", { href: "http://go/techops", target: "_blank", rel: "noopener noreferrer" }, "Techops"),
                    " ",
                    "and",
                    " ",
                    React.createElement("a", { href: "http://go/torq", target: "_blank", rel: "noopener noreferrer" }, "TORQ"))),
            selectedAction === WargameAction.Exercise && (React.createElement("div", null,
                React.createElement("br", null),
                React.createElement(WargameExerciseForm, null),
                React.createElement("br", null)))),
        React.createElement(WargameActionOption, { value: WargameAction.Plan, onChange: setSelectedAction, selectedAction: selectedAction, title: "Create Adhoc Wargame Experiment" },
            React.createElement("ul", null,
                React.createElement("li", null, "This option is specifically intended for Adhoc testing when you don't need to keep track of Wargame(WG) and Action item tickets. The main purpose of this option is to validate/test your wargame plans.")))));
};
var WargameActionOption = function (_a) {
    var value = _a.value, onChange = _a.onChange, selectedAction = _a.selectedAction, title = _a.title, children = _a.children;
    return (React.createElement("div", null,
        React.createElement(InlineDiv, null,
            React.createElement(Radio, { value: value, label: React.createElement("h4", null, title), name: "action", isChecked: selectedAction === value, onChange: function (e) { return onChange(e.target.value); } }),
            title === createWargameExerciseTitle ? (React.createElement(LabelDiv, null,
                React.createElement(Lozenge, { appearance: "inprogress" }, "Recommended"))) : (React.createElement(React.Fragment, null))),
        React.createElement("br", null),
        React.createElement("div", null, children),
        React.createElement("br", null)));
};
var createWargameExerciseTitle = "Create Wargame Exercise";
var InlineDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var LabelDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 3px;\n"], ["\n  margin-left: 3px;\n"])));
var templateObject_1, templateObject_2;
